(function () {
	'use strict';

	var ACTIVE_CLASS = 'is-active';
	var STUCK_CLASS = 'is-stuck';
	var EMPTY_CLASS = 'is-empty';
	var UNAVAILABLE_CLASS = 'is-unavailable';
	var HAS_ACTIVE_CLASS = 'has-active';
	var LOCK_DURATION = 700;

	function toArray(list) {
		return Array.prototype.slice.call(list);
	}

	function absoluteTop(el) {
		return el.getBoundingClientRect().top + window.pageYOffset;
	}

	
	function offsetWithin(scroller, el) {
		return el.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
	}

	function prefersReducedMotion() {
		return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}

	function resolveTarget(selector) {
		if (!selector) return null;

		var el = null;
		try {
			el = document.querySelector(selector);
		} catch (e) {
			el = null;
		}

		
		if (!el && selector.charAt(0) === '#') {
			el = document.getElementById(selector.slice(1));
		}

		return el;
	}

	function AnchorNav(root) {
		this.root = root;
		
		this.sticky = root.closest('.shopify-section-product-anchor-nav') || root;
		this.scroller = root.querySelector('[data-anchor-scroller]');
		this.indicator = root.querySelector('[data-anchor-indicator]');
		this.items = [];
		this.unresolved = [];
		this.activeIndex = -1;
		this.lockedUntil = 0;
		this.ticking = false;

		this.onScroll = this.onScroll.bind(this);
		this.onResize = this.onResize.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onLoad = this.onLoad.bind(this);
		this.onLayoutChange = this.onLayoutChange.bind(this);

		this.collect();
		this.measure();
		this.bind();
		this.update();
		this.jumpToHash();
	}

	AnchorNav.prototype.collect = function () {
		var self = this;

		this.items = [];
		this.unresolved = [];

		toArray(this.root.querySelectorAll('[data-anchor-target]')).forEach(function (link) {
			var selector = link.getAttribute('data-anchor-target');
			var target = resolveTarget(selector);

			
			if (!target) {
				link.classList.add(UNAVAILABLE_CLASS);
				self.unresolved.push(selector);
				return;
			}

			link.classList.remove(UNAVAILABLE_CLASS);
			self.items.push({ link: link, target: target });
		});

		
		this.items.sort(function (a, b) {
			var relation = a.target.compareDocumentPosition(b.target);

			if (relation & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
			if (relation & Node.DOCUMENT_POSITION_PRECEDING) return 1;
			return 0;
		});

		// Links in dezelfde volgorde zetten als de secties op de pagina. Zo klopt het menu
		// ook als de volgorde op mobiel anders is dan op desktop (bijv. accessoires).
		var anchorEl = this.indicator && this.indicator.parentNode === this.scroller ? this.indicator : null;
		if (this.scroller) {
			for (var n = 0; n < this.items.length; n++) {
				this.scroller.insertBefore(this.items[n].link, anchorEl);
			}
		}

		
		this.root.classList.toggle(EMPTY_CLASS, this.items.length === 0);
		this.root.classList.remove(HAS_ACTIVE_CLASS);

		this.activeIndex = -1;
	};

	AnchorNav.prototype.indexOfLink = function (link) {
		for (var i = 0; i < this.items.length; i++) {
			if (this.items[i].link === link) return i;
		}
		return -1;
	};

	AnchorNav.prototype.measure = function () {
		this.stickyTop = parseFloat(window.getComputedStyle(this.sticky).top) || 0;
		this.height = this.sticky.getBoundingClientRect().height;
	};

	AnchorNav.prototype.bind = function () {
		window.addEventListener('scroll', this.onScroll, { passive: true });
		window.addEventListener('resize', this.onResize);
		window.addEventListener('load', this.onLoad);
		document.addEventListener('pp:layout-change', this.onLayoutChange);
		this.root.addEventListener('click', this.onClick);
	};

	AnchorNav.prototype.destroy = function () {
		window.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.onResize);
		window.removeEventListener('load', this.onLoad);
		document.removeEventListener('pp:layout-change', this.onLayoutChange);
		this.root.removeEventListener('click', this.onClick);
	};

	
	AnchorNav.prototype.onLoad = function () {
		if (this.unresolved.length) {
			this.collect();
		}

		this.measure();
		this.update();

		if (this.unresolved.length && window.console && window.console.warn) {
			window.console.warn(
				'[anchor-nav] Geen element gevonden voor: ' + this.unresolved.join(', ') +
				'. Deze links zijn verborgen. Controleer of de sectie op deze productpagina staat en het opgegeven id bestaat.'
			);
		}
	};

	// Secties zijn verplaatst (mobiele volgorde): doelen en linkvolgorde opnieuw bepalen.
	AnchorNav.prototype.onLayoutChange = function () {
		this.collect();
		this.measure();
		this.update();
		this.positionIndicator();
	};

	AnchorNav.prototype.onResize = function () {
		this.measure();
		this.update();
		this.positionIndicator();
	};

	AnchorNav.prototype.onScroll = function () {
		if (this.ticking) return;

		this.ticking = true;
		var self = this;
		window.requestAnimationFrame(function () {
			self.ticking = false;
			self.update();
		});
	};

	AnchorNav.prototype.onClick = function (e) {
		var link = e.target && e.target.closest ? e.target.closest('[data-anchor-target]') : null;
		if (!link) return;

		var index = this.indexOfLink(link);
		if (index < 0) return;

		e.preventDefault();
		this.lockedUntil = Date.now() + LOCK_DURATION;
		this.setActive(index);
		this.scrollToItem(this.items[index]);
		this.syncHash(link);
	};

	
	AnchorNav.prototype.offset = function () {
		return this.stickyTop + this.height;
	};

	AnchorNav.prototype.update = function () {
		this.root.classList.toggle(STUCK_CLASS, this.sticky.getBoundingClientRect().top <= this.stickyTop + 0.5);

		if (!this.items.length || Date.now() < this.lockedUntil) return;

		var line = window.pageYOffset + this.offset() + 12;
		var bottomReached = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;
		var index = 0;

		if (bottomReached) {
			index = this.items.length - 1;
		} else {
			for (var i = 0; i < this.items.length; i++) {
				if (absoluteTop(this.items[i].target) > line) break;
				index = i;
			}
		}

		this.setActive(index);
	};

	AnchorNav.prototype.setActive = function (index) {
		if (!this.items[index]) return;
		if (index === this.activeIndex) {
			this.positionIndicator();
			return;
		}

		if (this.items[this.activeIndex]) {
			var previous = this.items[this.activeIndex].link;
			previous.classList.remove(ACTIVE_CLASS);
			previous.removeAttribute('aria-current');
		}

		this.activeIndex = index;

		var link = this.items[index].link;
		link.classList.add(ACTIVE_CLASS);
		link.setAttribute('aria-current', 'true');
		this.positionIndicator();
		this.revealLink(link);
	};

	AnchorNav.prototype.positionIndicator = function () {
		var item = this.items[this.activeIndex];
		if (!this.indicator || !this.scroller || !item) return;

		var left = offsetWithin(this.scroller, item.link);
		this.indicator.style.width = item.link.getBoundingClientRect().width + 'px';
		this.indicator.style.transform = 'translate3d(' + left + 'px, 0, 0)';
		this.root.classList.add(HAS_ACTIVE_CLASS);
	};

	
	AnchorNav.prototype.revealLink = function (link) {
		var scroller = this.scroller;
		if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;

		var left = offsetWithin(scroller, link) - (scroller.clientWidth - link.offsetWidth) / 2;
		var max = scroller.scrollWidth - scroller.clientWidth;

		if (left < 0) left = 0;
		if (left > max) left = max;

		if (scroller.scrollTo) {
			scroller.scrollTo({ left: left, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
		} else {
			scroller.scrollLeft = left;
		}
	};

	AnchorNav.prototype.scrollToItem = function (item, instant) {
		var top = absoluteTop(item.target) - this.offset() - 12;
		if (top < 0) top = 0;

		window.scrollTo({
			top: top,
			behavior: instant || prefersReducedMotion() ? 'instant' : 'smooth'
		});
	};

	AnchorNav.prototype.syncHash = function (link) {
		var href = link.getAttribute('href');
		if (!href || href === '#' || !window.history || !window.history.replaceState) return;

		window.history.replaceState(null, '', href);
	};

	
	AnchorNav.prototype.jumpToHash = function () {
		var hash = window.location.hash;
		if (!hash || hash.length < 2) return;

		var self = this;
		var match = null;

		this.items.forEach(function (item) {
			if (item.link.getAttribute('href') === hash) match = item;
		});

		if (!match) return;

		window.requestAnimationFrame(function () {
			self.measure();
			self.scrollToItem(match, true);
			self.lockedUntil = 0;
			self.update();
		});
	};

	var instances = [];

	function init(scope) {
		toArray((scope || document).querySelectorAll('[data-anchor-nav]')).forEach(function (root) {
			if (root.dataset.anchorNavReady) return;

			root.dataset.anchorNavReady = 'true';
			instances.push(new AnchorNav(root));
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', function (e) {
		init(e.target);
	});

	document.addEventListener('shopify:section:unload', function (e) {
		instances = instances.filter(function (instance) {
			if (!e.target.contains(instance.root)) return true;
			instance.destroy();
			return false;
		});
	});
})();
